import {
  updateCurrentWorkoutExerciseAction,
  updateCurrentWorkoutSectionAction
} from '@gymaholic/packages'
// import { PlusIcon } from 'components/Icon/icons/plus'
import React from 'react'
import Button from 'components/Button/index.js'
import { DotsIcon } from 'components/Icon/icons/dots/index.js'
import openModalAction from 'modules/modal/actions/open/index.js'
import { MODAL_ID } from 'modules/modal/constants/index.cjs'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import openAppSignInModalAction from 'modules/modal/actions/open-app-sign-in/index.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen/index.js'
import { isLoggedInTrainingUserSelect } from 'modules/training/modules/training-users/selectors/is-logged-in/index.js'

const WIDTH_ICON_DESKTOP_IN_PX = '24px'
const WIDTH_ICON_SMALL_SCREEN_IN_PX = '14px'

/**
 * @param workoutExerciseId
 * @param workoutSectionId
 * @param setIndex
 * @returns {JSX.Element}
 * @constructor
 */
export default function SetRowMenuIcon ({
  workoutExerciseId,
  workoutSectionId,
  setIndex
}) {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const width = isSmallScreen
    ? WIDTH_ICON_SMALL_SCREEN_IN_PX
    : WIDTH_ICON_DESKTOP_IN_PX
  const dispatch = useDispatch()
  const isLoggedIn = useSelector(isLoggedInTrainingUserSelect)

  const handleClickMenu = () => {
    if (!isLoggedIn) {
      dispatch(openAppSignInModalAction())
      return
    }

    dispatch(updateCurrentWorkoutSectionAction(workoutSectionId))
    dispatch(updateCurrentWorkoutExerciseAction(workoutExerciseId))
    dispatch(openModalAction(
      MODAL_ID.SET_ROW_MENU,
      {
        workoutExerciseId,
        setIndex
      }
    ))
  }

  return (
    <Button
      onClick={handleClickMenu}
      style={{ height: 'unset' }}
    >
      <DotsIcon
        style={{
          width
        }}
      />
    </Button>
  )
}
